import React, { useContext, useEffect, useState } from "react";

import { Container, Card, Form, Button, Spinner } from "react-bootstrap";

import { ArrowLeft, Send, Pencil, Trash2, Save } from "lucide-react";

import { useNavigate, useParams } from "react-router-dom";

import "../../../assets/css/admin/supportticket/chatpage.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const ChatpageInAdmin = () => {
  const [messages, setMessages] = useState([]);
  const { baseUrl,regTpChecker } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedMessageId, setSelectedMessageId] = useState(null);
  const [idToUpdateDeletemessage, setIdToUpdateDeletemessage] = useState("");
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [loadingEditId, setLoadingEditId] = useState(null);
  const [loadingDeleteId, setLoadingDeleteId] = useState(null);
  const [message, setMessage] = useState("");

  const [ticketDetail, setTicketDetail] = useState({});
  const navigate = useNavigate();

  const { id } = useParams();
  const sendMessage = () => {
 
    // console.log(, answer, selectedType);


const admin = JSON.parse(localStorage.getItem("loggedInAdmin"));

const formData = new FormData();


formData.append("tphelpsupport_id", id);
formData.append("tpadmin_id", admin.id);
formData.append("message", message);
formData.append("sender", "admin");
   for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]);
}
    axios
      .post(`${baseUrl}/admin/chat/sendMessage`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        setAddUploadLoading(false);
        viewAllUploadedMessage();
        resetForm();

        Swal.fire({
          icon: "success",
          title: "Congrats",
          text: "Message created successfully",
          confirmButtonText: "Cool",
        });
      })
      .catch((err) => {
        console.log(err.response.data);
        // console.log(err);
        setAddUploadLoading(false);
      });
  };
  // ---------------- FETCH Message ----------------
  const viewAllUploadedMessage = () => {
    axios
      .get(`${baseUrl}/admin/chat/viewAllUploadedMessage`)
      .then((response) => {
        console.log(response.data);
        setMessages(response.data.message);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };
  const updateMessage = () => {
    const formData = new FormData();
    formData.append("id", idToUpdateDeletemessage);
    formData.append("tphelpsupport_id", id);
    formData.append("message", message);
    formData.append("sender", "admin");

    axios
      .post(`${baseUrl}/admin/chat/updateMessage`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        viewAllUploadedMessage();
        resetForm();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };
  const deleteMessage = (idToDelete) => {
    const formData = new FormData();
    formData.append("id", idToDelete);
    axios
      .post(`${baseUrl}/admin/chat/deleteMessage`, formData)
      .then(() => {
        viewAllUploadedMessage();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };
  // ---------------- RESET FORM ----------------
  const resetForm = () => {
    setMessage("");
    setIdToUpdateDeletemessage("");
    setSelectedMessageId(null);

    setLoadingEditId(null);
    setLoadingDeleteId(null);
    setAddUploadLoading(false);
  };
  useEffect(() => {
    viewAllUploadedMessage();
  }, []);
  console.log(messages);
  return (
    <AdminMasterLayout>
      <Container fluid className="ticket-chat-wrapper">
        {/* Header */}
        <div className="ticket-chat-header">
          <button className="back-btn" onClick={() => navigate(-1)}>
            {" "}
            <ArrowLeft size={18} />{" "}
          </button>
            {/* Error Message */}
            {errorMessage && (
              <div className="buyer-error-message">{errorMessage}</div>
            )}

          <div>
            <h3 className="chat-title">Payment not received</h3>

            <p className="chat-subtitle">
              I completed order ORD-002 but payment is not showing in my wallet.
            </p>
          </div>
        </div>

        {/* Card */}
        <Card className="chat-card">
          <div className="chat-top">Chat — {id}</div>

          {/* Messages */}
          <div className="messages-wrapper">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className={`message-row ${
                  msg.sender === "admin" ? "admin-row" : "seller-row"
                }`}
                onClick={() => setSelectedMessageId(msg.id)}
              >
                <div
                  className={`message-bubble ${
                    msg.sender === "admin" ? "admin-bubble" : "seller-bubble"
                  }`}
                >
                  <p>{msg.message}</p>

                  <span>{msg.sender}</span>

                  {/* EDIT DELETE ICONS */}
                  {selectedMessageId === msg.id && (
                    <div className="d-flex gap-2 mt-2 align-items-center">
                      <Button
                        size="sm"
                        variant="warning"
                        disabled={loadingEditId === msg.id}
                        onClick={() => {
                          setLoadingEditId(msg.id);

                          setTimeout(() => {
                            setMessage(msg.message);
                            setIdToUpdateDeletemessage(msg.id);

                            setLoadingEditId(null);
                          }, 500);
                        }}
                      >
                        {loadingEditId === msg.id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <Pencil size={16} />
                        )}
                      </Button>

                      <Button
                        size="sm"
                        variant="danger"
                        disabled={loadingDeleteId === msg.id}
                        onClick={() => {
                          setLoadingDeleteId(msg.id);

                          deleteMessage(msg.id);
                        }}
                      >
                        {loadingDeleteId === msg.id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <Trash2 size={16} />
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* Input */}
          <div className="chat-input-wrapper">
            <Form.Control
              placeholder="Type a message..."
              value={message}
              onChange={(e) => {setMessage(e.target.value)
                setErrorMessage(regTpChecker("message", e.target.value));
              }}
            />

            <Button
              className="send-btn"
              onClick={() => {
                setAddUploadLoading(true);

                if (idToUpdateDeletemessage) {
                  updateMessage();
                } else {
                  sendMessage();
                }
              }}
            >
              {addUploadLoading ? (
                <Spinner animation="border" size="sm" />
              ) : idToUpdateDeletemessage ? (
                <Save size={16} />
              ) : (
                <Send size={16} />
              )}
            </Button>
          </div>
        </Card>
      </Container>
    </AdminMasterLayout>
  );
};

export default ChatpageInAdmin;
